module.exports = __webpack_public_path__ + "static/media/buy_donate.544e7e57.svg";